(() => {
  const clean = (value) => String(value || '').replace(/\s+/g,' ').trim();
  const sentences = (text) => clean(text).match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [];
  const addIntro = (panel, text) => {
    const header = panel?.querySelector('.lv-tab-title');
    if (!header || panel.querySelector('.lvc-panel-intro')) return;
    const p = document.createElement('p');
    p.className = 'lvc-panel-intro';
    p.textContent = text;
    header.insertAdjacentElement('afterend', p);
  };
  const buildHighlights = (root, description) => {
    const panel = root.querySelector('[data-panel="description"]');
    const content = panel?.querySelector('.lv-panel-content');
    if (!content || content.querySelector('.lvc-description-highlights')) return;
    const excluded = /(env[ií]o|devoluci|reembolso|365 d[ií]as|pago|pedido)/i;
    const items = sentences(description)
      .map(clean)
      .filter((item) => item.length >= 38 && item.length <= 210 && !excluded.test(item))
      .slice(0,4);
    if (!items.length) return;
    const box = document.createElement('div');
    box.className = 'lvc-description-highlights';
    box.innerHTML = '<strong class="lvc-description-highlights__title">Lo más importante de este modelo</strong><ul>' +
      items.map((item) => '<li>' + item.replace(/[<>]/g,'') + '</li>').join('') +
      '</ul>';
    const intro = content.querySelector('.lvc-panel-intro');
    if (intro) intro.insertAdjacentElement('afterend', box);
    else content.prepend(box);
  };
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.lv-pdp-tabs').forEach((root) => {
      root.classList.add('lvc-cro-tabs');
      let data = {};
      try { data = JSON.parse(root.querySelector('.lv-product-source')?.textContent || '{}'); } catch(e) {}
      addIntro(root.querySelector('[data-panel="description"]'), 'Una visión rápida y clara para saber si este modelo encaja contigo antes de elegir talla.');
      addIntro(root.querySelector('[data-panel="technology"]'), 'Materiales y soluciones técnicas explicados de forma sencilla, sin perderte entre términos.');
      addIntro(root.querySelector('[data-panel="features"]'), 'Los puntos clave del artículo reunidos para que compares más rápido.');
      addIntro(root.querySelector('[data-panel="care"]'), 'Consejos prácticos para acertar con la talla y mantener el calzado en buenas condiciones.');
      addIntro(root.querySelector('[data-panel="faq"]'), 'Resolvemos las dudas más habituales antes de comprar.');
      addIntro(root.querySelector('[data-panel="shipping"]'), 'Plazos, cambios y devoluciones explicados de forma directa antes de finalizar tu compra.');
      buildHighlights(root, data.description || '');
      const descSummary = root.querySelector('[data-panel="description"] .lv-part-details > summary');
      if (descSummary) descSummary.textContent = 'Descripción completa del modelo';
    });
  });
})();